// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

import React from 'react';
import { createRoot } from 'react-dom/client';
import TeamCards from './TeamCards';
import CounterApp from './Counters';
import Alert from './Alert';
import MobileNav from './MobileNav';


const reactRootElement = document.getElementById('react_app_team');
const reactCountersRootElement = document.getElementById('react_app_counter');
const reactAlertRootElement = document.getElementById('react_app_alert');
const reactMobileNavRootElement = document.getElementById('react_app_mobile_nav');

// TEAM CARDS
if (reactRootElement) {
    const root = createRoot(reactRootElement);
    root.render(<TeamCards />);
}

// COUNTER ANIMATED CARDS ON INDEX
if (reactCountersRootElement) {
    function extractNumber(str) {
        const match = str.match(/[0-9.]+/); // This will match numbers, including decimals
        return match ? parseFloat(match[0]) : str; // Convert the matched string to a number
    }
    try{
        let data_array = [];
        let counter_data = reactCountersRootElement.querySelectorAll('article');
        for(let item of counter_data){
            let get_number = item.querySelector('[data-react-number]').getAttribute('data-react-number');
            let extracted_number = extractNumber(get_number);
            let extra_symbol = get_number.replace(String(extracted_number), '');

            let get_text = item.querySelector('[data-react-text]').getAttribute('data-react-text');
            data_array.push(
                {'number':extracted_number, 'symbol': extra_symbol, 'is_num':!isNaN(extracted_number), 'text':get_text }
            )

        }
        const root = createRoot(reactCountersRootElement);
        root.render(<CounterApp counter_data={data_array}/>);
    }catch(err){
        console.log('[x] error loading react counter cards...');
    }
}

if(reactAlertRootElement){
    const root = createRoot(reactAlertRootElement);
    root.render(<Alert/>);
}

if(reactMobileNavRootElement){
    const root = createRoot(reactMobileNavRootElement);
    root.render(<MobileNav/>);
}


